import { useQuery } from '@tanstack/react-query';
import apiClient from '../api/config';
import { fetchEventoWaitlist, EventWaitlistEntry } from '../api/eventoService';
import { useTenantCode } from './useTenantCode';

// D1 — vistas de administración de la lista de espera. Solo lectura: el portal
// del cliente nunca enseña la cola, pero el centro necesita poder mirarla.

export const useEventWaitlistQuery = (eventoId?: string, enabled = true) => {
    const tenantCode = useTenantCode();
    return useQuery<EventWaitlistEntry[]>({
        queryKey: ['waitlist', 'evento', tenantCode, eventoId],
        queryFn: () => fetchEventoWaitlist(eventoId as string),
        enabled: Boolean(tenantCode && eventoId && enabled),
    });
};

/** Una clase que el cliente está esperando, tal y como la devuelve el backend. */
export interface ClientWaitlistEntry {
    _id: string;
    createdAt: string;
    eventId: {
        _id: string;
        fecha: string;
        horaInicio: string;
        horaFin: string;
        sala?: string;
        nivel_id?: { nombre: string; color?: string };
    } | null;
}

export const useClientWaitlistsQuery = (clientId?: string) => {
    const tenantCode = useTenantCode();
    return useQuery<ClientWaitlistEntry[]>({
        queryKey: ['waitlist', 'client', tenantCode, clientId],
        queryFn: () => apiClient.get(`/clients/${clientId}/waitlists`).then((r) => r.data),
        enabled: Boolean(tenantCode && clientId),
    });
};
